export default function (url, data) {
    // Do not change header type: https://stackoverflow.com/questions/45274021/sendbeacon-api-not-working-temporarily-due-to-security-issue-any-workaround
    //landmark=usage is important option for akamai bot whitelisting
    const headers = {type: 'text/plain;landmark=usage'};
    const json = data ? JSON.stringify(data) : '{}';
    const dataBlob = new Blob([json], headers);
    return navigator.sendBeacon(url, dataBlob);
}